import {
  FormSubmitController,
  l as l2
} from "./chunk.NYKU5T7J.js";
import {
  o
} from "./chunk.ONXLNBOP.js";
import {
  focusVisibleSelector
} from "./chunk.6JE2K3D5.js";
import {
  emit
} from "./chunk.T3VOOO5F.js";
import {
  watch
} from "./chunk.H7XADNZ7.js";
import {
  l
} from "./chunk.Z4OOI5NQ.js";
import {
  e,
  i2,
  n,
  t
} from "./chunk.5E26GMTR.js";
import {
  $,
  component_styles_default,
  r,
  s4
} from "./chunk.3PRAXUFA.js";
import {
  __decorateClass
} from "./chunk.7RPYXGIF.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.7EHHFVMB.js
var switch_styles_default = r` ${component_styles_default} :host { --height: var(--sl-toggle-size); --thumb-size: calc(var(--sl-toggle-size) + 4px); --width: calc(var(--height) * 2); display: inline-block; } .switch { display: inline-flex; align-items: center; font-family: var(--sl-input-font-family); font-size: var(--sl-input-font-size-medium); font-weight: var(--sl-input-font-weight); color: var(--sl-input-color); vertical-align: middle; cursor: pointer; } .switch__control { flex: 0 0 auto; position: relative; display: inline-flex; align-items: center; justify-content: center; width: var(--width); height: var(--height); background-color: var(--sl-color-neutral-400); border: solid var(--sl-input-border-width) var(--sl-color-neutral-400); border-radius: var(--height); transition: var(--sl-transition-fast) border-color, var(--sl-transition-fast) background-color; } .switch__control .switch__thumb { width: var(--thumb-size); height: var(--thumb-size); background-color: var(--sl-color-neutral-0); border-radius: 50%; border: solid var(--sl-input-border-width) var(--sl-color-neutral-400); transform: translateX(calc((var(--width) - var(--height)) / -2)); transition: var(--sl-transition-fast) transform ease, var(--sl-transition-fast) background-color, var(--sl-transition-fast) border-color, var(--sl-transition-fast) box-shadow; } .switch__input { position: absolute; opacity: 0; padding: 0; margin: 0; pointer-events: none; } /* Hover */ .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover { background-color: var(--sl-color-neutral-400); border-color: var(--sl-color-neutral-400); } .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover .switch__thumb { background-color: var(--sl-color-neutral-0); border-color: var(--sl-color-neutral-400); } /* Focus */ .switch:not(.switch--checked):not(.switch--disabled) .switch__input${focusVisibleSelector} ~ .switch__control { background-color: var(--sl-color-neutral-400); border-color: var(--sl-color-neutral-400); } .switch:not(.switch--checked):not(.switch--disabled) .switch__input${focusVisibleSelector} ~ .switch__control .switch__thumb { background-color: var(--sl-color-neutral-0); border-color: var(--sl-color-primary-600); box-shadow: var(--sl-focus-ring); } /* Checked */ .switch--checked .switch__control { background-color: var(--sl-color-primary-600); border-color: var(--sl-color-primary-600); } .switch--checked .switch__control .switch__thumb { background-color: var(--sl-color-neutral-0); border-color: var(--sl-color-primary-600); transform: translateX(calc((var(--width) - var(--height)) / 2)); } /* Checked + hover */ .switch.switch--checked:not(.switch--disabled) .switch__control:hover { background-color: var(--sl-color-primary-600); border-color: var(--sl-color-primary-600); } .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb { background-color: var(--sl-color-neutral-0); border-color: var(--sl-color-primary-600); } /* Checked + focus */ .switch.switch--checked:not(.switch--disabled) .switch__input${focusVisibleSelector} ~ .switch__control { background-color: var(--sl-color-primary-600); border-color: var(--sl-color-primary-600); } .switch.switch--checked:not(.switch--disabled) .switch__input${focusVisibleSelector} ~ .switch__control .switch__thumb { background-color: var(--sl-color-neutral-0); border-color: var(--sl-color-primary-600); box-shadow: var(--sl-focus-ring); } /* Disabled */ .switch--disabled { opacity: 0.5; cursor: not-allowed; } .switch__label { line-height: var(--height); margin-left: 0.5em; user-select: none; } `;

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.WVNZTNX2.js
var SlSwitch = class extends s4 {
  constructor() {
    super(...arguments);
    this.formSubmitController = new FormSubmitController(this, {
      value: (control) => control.checked ? control.value : void 0
    });
    this.hasFocus = false;
    this.disabled = false;
    this.required = false;
    this.checked = false;
    this.invalid = false;
  }
  firstUpdated() {
    this.invalid = !this.input.checkValidity();
  }
  click() {
    this.input.click();
  }
  focus(options) {
    this.input.focus(options);
  }
  blur() {
    this.input.blur();
  }
  reportValidity() {
    return this.input.reportValidity();
  }
  setCustomValidity(message) {
    this.input.setCustomValidity(message);
    this.invalid = !this.input.checkValidity();
  }
  handleBlur() {
    this.hasFocus = false;
    emit(this, "sl-blur");
  }
  handleCheckedChange() {
    this.input.checked = this.checked;
    this.invalid = !this.input.checkValidity();
  }
  handleClick() {
    this.checked = !this.checked;
    emit(this, "sl-change");
  }
  handleDisabledChange() {
    this.input.disabled = this.disabled;
    this.invalid = !this.input.checkValidity();
  }
  handleFocus() {
    this.hasFocus = true;
    emit(this, "sl-focus");
  }
  handleKeyDown(event) {
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      this.checked = false;
      emit(this, "sl-change");
    }
    if (event.key === "ArrowRight") {
      event.preventDefault();
      this.checked = true;
      emit(this, "sl-change");
    }
  }
  render() {
    return $`<label part="base" class=${o({
      switch: true,
      "switch--checked": this.checked,
      "switch--disabled": this.disabled,
      "switch--focused": this.hasFocus
    })} ><input class="switch__input" type="checkbox" name=${l(this.name)} value=${l(this.value)} .checked=${l2(this.checked)} .disabled=${this.disabled} .required=${this.required} role="switch" aria-checked=${this.checked ? "true" : "false"} @click=${this.handleClick} @blur=${this.handleBlur} @focus=${this.handleFocus} @keydown=${this.handleKeyDown} /><span part="control" class="switch__control"><span part="thumb" class="switch__thumb"></span></span><span part="label" class="switch__label"><slot></slot></span></label>`;
  }
};
SlSwitch.styles = switch_styles_default;
__decorateClass([
  i2('input[type="checkbox"]')
], SlSwitch.prototype, "input", 2);
__decorateClass([
  t()
], SlSwitch.prototype, "hasFocus", 2);
__decorateClass([
  e()
], SlSwitch.prototype, "name", 2);
__decorateClass([
  e()
], SlSwitch.prototype, "value", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlSwitch.prototype, "disabled", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlSwitch.prototype, "required", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlSwitch.prototype, "checked", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlSwitch.prototype, "invalid", 2);
__decorateClass([
  watch("checked", { waitUntilFirstUpdate: true })
], SlSwitch.prototype, "handleCheckedChange", 1);
__decorateClass([
  watch("disabled", { waitUntilFirstUpdate: true })
], SlSwitch.prototype, "handleDisabledChange", 1);
SlSwitch = __decorateClass([
  n("sl-switch")
], SlSwitch);

export {
  SlSwitch
};
